import TrendsReportList from './TrendsReportList.container';

export default TrendsReportList;
